module.exports = __webpack_public_path__ + "img/insect-station.35348ba2.png";